<template>
  <v-dialog :value="value" persistent max-width="800px">
    <v-form v-if="value" v-model="formValid" ref="form">
      <v-card>
        <v-subheader class="primary headline white--text" style="width: 100%"
          >{{ $t("common.newTravel") }}
        </v-subheader>
        <v-card-text class="px-7">
          <DragAndDrop
            :title="this.$t('itinerary.NewTravel.titleDD')"
            v-on:update:file="image = $event"
            :initial="currentImage"
            @imagepath="recycledImagePath = $event"
          />
          <v-text-field
            v-model="newTravel.name"
            :label="this.$t('common.name')"
            required
            :rules="[rules.required]"
            prepend-icon="mdi-pencil"
          ></v-text-field>
          <div style="height: 200px; border: 1px solid #ccc !important; border-radius: 12px">
            <quill-editor
              class="editor"
              ref="myQuillEditor"
              :options="editorOption"
              @ready="onEditorReady"
            />
          </div>
          <v-card v-if="savedPDF || pdf" class="py-auto text-right mt-4 pt-1" max-width="200px">
            <v-btn v-if="pdf" icon @click="clearPDF"><v-icon>mdi-close</v-icon></v-btn>
            <v-img
              class="mx-auto"
              width="100px"
              height="100px"
              contain
              :src="require('@/assets/pdf.png')"
            >
            </v-img>
            <h4 class="mt-3 mx-auto py-2 text-center grey lighten-2">
              {{ pdf != null ? pdf.name : savedPDF }}
            </h4>
          </v-card>
          <input
            type="file"
            multiple
            style="display: none"
            ref="pdf"
            accept="application/pdf"
            @change="onPDFPicked"
          />
          <v-btn class="mt-4" tile text color="primary" @click="$refs.pdf.click()">
            <v-icon left>mdi-file-pdf-box</v-icon>
            {{ $t("common.pdf") }}
          </v-btn>
          <v-row no-gutters>
            <v-col cols="2">
              <div class="d-flex flex-row align-center mt-3">
                <v-icon>mdi-location-enter</v-icon>
                <h4 class="mx-4 mt-2">{{ $t("common.departure") }}</h4>
              </div>
            </v-col>
            <v-col>
              <div class="d-flex flex-column">
                <v-row no-gutters>
                  <v-col>
                    <v-text-field
                      v-model="newTravel.origin.name"
                      prepend-icon="mdi-map-marker"
                      placeholder="Place name"
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-select
                      class="mx-4"
                      :items="cities"
                      v-model="departureCity"
                      :disabled="departureCity != null && newTravel.origin.coordinates != null"
                      label="City"
                      style="max-width: 200px"
                      item-text="id"
                      return-object
                      @change="cityChanged($event, 'departure')"
                    ></v-select>
                  </v-col>
                  <v-col>
                    <v-text-field
                      :value="newTravel.origin.address"
                      readonly
                      label="Address"
                      append-icon="mdi-pencil"
                      @click="openMap('departure')"
                      @click:append="openMap('departure')"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col>
                    <DatePickerField :label="$t('common.date')" v-model="departureDate" />
                  </v-col>

                  <v-col class="d-flex flex-row align-center">
                    <v-icon class="ml-4">mdi-clock-outline</v-icon>
                    <vue-timepicker
                      class="ml-2"
                      fixed-dropdown-button
                      format="h:mm a"
                      :placeholder="$t('common.time.time')"
                      input-width="160px"
                      v-model="departureTime"
                      manual-input
                      close-on-complete
                    ></vue-timepicker>
                  </v-col>
                  <v-col>
                    <v-autocomplete
                      :items="timeZones"
                      v-model="departureTimezone"
                      item-text="city"
                      :label="$t('common.timezone')"
                      :rules="[rules.required]"
                      return-object
                      prepend-icon="mdi-map-clock"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2">
              <div class="d-flex flex-row align-center mt-3">
                <v-icon> mdi-location-exit </v-icon>
                <h4 class="mx-4 mt-2">{{ $t("common.arrival") }}</h4>
              </div>
            </v-col>
            <v-col>
              <div class="d-flex flex-column">
                <div class="d-flex flex-row">
                  <v-text-field
                    prepend-icon="mdi-map-marker"
                    v-model="newTravel.destin.name"
                    placeholder="Place name"
                  ></v-text-field>
                  <!-- :value="newEvent.location.city" -->
                  <v-select
                    class="mx-4"
                    :items="cities"
                    v-model="arrivalCity"
                    :disabled="arrivalCity != null && newTravel.destin.coordinates != null"
                    label="City"
                    style="max-width: 200px"
                    item-text="id"
                    return-object
                    @change="cityChanged($event, 'arrival')"
                  ></v-select>
                  <!-- :placeholder="$t('common.location')" -->
                  <v-text-field
                    :value="newTravel.destin.address"
                    readonly
                    label="Address"
                    append-icon="mdi-pencil"
                    @click="openMap('arrival')"
                    @click:append="openMap('arrival')"
                  ></v-text-field>
                </div>
                <div class="d-flex flex-row align-center">
                  <DatePickerField v-model="arrivalDate" />
                  <v-icon class="ml-4">mdi-clock-outline</v-icon>
                  <vue-timepicker
                    class="ml-2"
                    fixed-dropdown-button
                    format="h:mm a"
                    :placeholder="$t('common.time.time')"
                    input-width="160px"
                    v-model="arrivalTime"
                    manual-input
                    close-on-complete
                  ></vue-timepicker>
                  <v-autocomplete
                    :items="timeZones"
                    v-model="arrivalTimezone"
                    item-text="city"
                    :label="$t('common.timezone')"
                    :rules="[rules.required]"
                    return-object
                    prepend-icon="mdi-map-clock"
                  ></v-autocomplete>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-dialog v-model="mapDialog" width="600">
            <v-card v-if="mapDialog">
              <div class="">
                <v-btn
                  class="float-right mr-2 mt-1"
                  icon
                  color="white"
                  text
                  @click="mapDialog = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <p class="white--text primary pa-2 ma-0 text-center">
                  Setting {{ mapForDeparture ? $t("common.origin") : $t("common.destination") }}
                </p>
                <p
                  v-if="departureMarker && departureMarker.address"
                  class="primary--text pa-2 ma-0 text-center"
                >
                  <v-icon color="#48ace9">mdi-map-marker</v-icon>
                  {{ $t("common.origin") }} - {{ departureMarker.address }}
                </p>
                <p
                  v-if="arrivalMarker && arrivalMarker.address"
                  class="primary--text pa-2 ma-0 text-center"
                >
                  <v-icon color="#ec2323">mdi-map-marker</v-icon> {{ $t("common.destination") }} -
                  {{ arrivalMarker.address }}
                </p>
              </div>
              <MglMap
                style="height: 400px"
                :accessToken="accessToken"
                :mapStyle="mapStyle"
                @load="mapLoaded"
              >
                <MglMarker
                  v-if="departureMarker"
                  anchor="bottom"
                  color="#48ace9"
                  :coordinates="departureMarker.coordinates"
                ></MglMarker>

                <MglMarker
                  v-if="arrivalMarker"
                  anchor="bottom"
                  color="#ec2323"
                  :coordinates="arrivalMarker.coordinates"
                ></MglMarker>

                <MglGeocoderControl
                  v-if="mapForDeparture"
                  :accessToken="accessToken"
                  :mapboxgl="mapboxgl"
                  :marker="false"
                  :placeholder="this.$t('common.origin')"
                  @result="selectedOrigin"
                />
                <MglGeocoderControl
                  v-if="!mapForDeparture"
                  :accessToken="accessToken"
                  :mapboxgl="mapboxgl"
                  :marker="false"
                  :placeholder="this.$t('common.destination')"
                  @result="selectedDestin"
                />
              </MglMap>
              <v-card-actions>
                <div class="flex-grow-1"></div>

                <v-btn
                  v-show="
                    (mapForDeparture && departureMarker) || (!mapForDeparture && arrivalMarker)
                  "
                  color="error"
                  text
                  @click="removePin"
                  >{{ this.$t("common.deletePin") }}
                </v-btn>
                <v-btn color="primary" @click="saveNewPoint">{{ $t("common.save") }} </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- {{ $t("itinerary.NewTravel.travelSettings") }} -->
          <!-- {{ $t("itinerary.NewTravel.travelRoute") }}

          <p v-if="newTravel.origin.address" class="white--text primary pa-2 ma-0 text-center">
            {{ $t("common.origin") }} - {{ newTravel.origin.address }}
          </p>
          <p v-if="newTravel.destin.address" class="white--text primary pa-2 ma-0 text-center">
            {{ $t("common.destination") }} - {{ newTravel.destin.address }}
          </p> -->
          <div class="d-flex flex-row align-top mt-4">
            <div class="mt-2">
              <v-icon class="">mdi-account-group</v-icon>
            </div>
            <h4 class="mx-4 mt-2">{{ $t("common.attendance") }}</h4>
            <div>
              <v-btn-toggle
                v-model="invitedMode"
                persistent-hint
                mandatory
                hin
                rounded
                dense
                color="primary"
              >
                <v-btn v-for="type in privacy" :key="type.value" :value="type.value">{{
                  type.text
                }}</v-btn>
              </v-btn-toggle>
              <p>{{ privacyHint }}</p>
            </div>
          </div>
          <div class="d-flex flex-row align-center mt-4" v-if="invitedMode == 3">
            <v-icon>mdi-format-list-bulleted</v-icon>
            <h4 class="mx-4">
              {{ $t("itinerary.NewEvent.selectedSubgroups") }}
            </h4>
            <v-select
              multiple
              v-model="subgroups"
              :items="allSubgroups"
              item-text="name"
              item-value="id"
              :label="this.$t('navbar.menu.subgroups')"
              single-line
            ></v-select>
          </div>
          <div class="d-flex flex-row align-center mt-4" v-if="invitedMode == 4">
            <v-icon>mdi-format-list-bulleted</v-icon>
            <h4 class="mx-4">{{ $t("common.selectedUsers") }}</h4>
            <v-select
              class="ml-6"
              multiple
              v-model="invitedUsers"
              :items="allUsers"
              item-text="name"
              item-value="id"
              :label="this.$t('common.attendance')"
              single-line
            ></v-select>
          </div>
          <div class="d-flex flex-row align-center mt-4">
            <v-icon> mdi-bell </v-icon>
            <h4 class="mx-4">{{ $t("common.notifications") }}</h4>
            <v-checkbox
              dense
              color="primary"
              v-model="newTravel.alarm"
              :label="this.$t('common.alarm')"
            ></v-checkbox>
            <v-select
              class="ml-4"
              dense
              :items="reminders"
              :label="this.$t('common.remindersHint')"
              hide-details
              v-model="newTravel.reminder"
            ></v-select>
          </div>
          <div class="d-flex flex-row align-center mt-4">
            <v-icon>mdi-chart-donut</v-icon>
            <h4 class="mx-4">Data</h4>

            <v-checkbox
              v-if="!newTravel.hide_date"
              color="primary"
              :persistent-hint="true"
              v-model="newTravel.attendance"
              :hint="this.$t('itinerary.NewEvent.attendanceHint')"
              :label="this.$t('itinerary.NewEvent.attendanceLabel')"
              :rules="[
                !newTravel.attendance ||
                  (newTravel.attendance && this.newTravel.origin.coordinates != null) ||
                  this.$t('common.rules.attendance'),
              ]"
            ></v-checkbox>

            <v-checkbox
              v-if="!newTravel.hide_date"
              class="ml-4"
              color="primary"
              persistent-hint
              v-model="newTravel.feedback"
              :hint="this.$t('common.feedbackFinal')"
              :label="this.$t('common.feedBackLabel')"
            ></v-checkbox>
          </div>
          <div class="text-right">
            <p v-if="feedback" class="red--text text-right mr-2">
              {{ feedback }}
            </p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeDialog">{{ $t("common.cancel") }}</v-btn>
          <v-btn color="primary" :loading="saving" @click="saveEvent">{{
            this.$t("common.save")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import DragAndDrop from "@/components/Base/DragAndDrop";
import DatePickerField from "@/components/Base/DatePickerField";
import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
import timezones from "@/assets/CitiesAndTimeZones.json";
import { quillEditor } from "vue-quill-editor";
import _ from "lodash";

import Mapbox from "mapbox-gl";
import { MglMap, MglMarker } from "v-mapbox";
import MglGeocoderControl from "@geospoc/v-mapbox-geocoder";

import moment from "moment-timezone";

import mbAPI from "@/APIS/mapbox-api";
import firestore from "@/firebase/firestore";
import storage from "@/firebase/storage";
import { uuid } from "vue-uuid";
import reminders from "@/assets/reminders";

export default {
  name: "NewTravel",
  props: ["value", "editTravel"],
  components: {
    DragAndDrop,
    MglMap,
    MglMarker,
    MglGeocoderControl,
    DatePickerField,
    VueTimepicker,
    quillEditor,
  },
  data(a) {
    return {
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["clean"],
            ["link"],
          ],
        },
        theme: "snow",
        placeholder: a.$t("common.description"),
      },
      mapDialog: false,
      mapForDeparture: false,
      invitedMode: 2,
      newTravel: {
        description: "",
        privacy: 2,
        reminder: null,
        alarm: false,
        feedback: false,
        attendance: false,

        origin: { address: null, coordinates: null },
        destin: { address: null, coordinates: null },
        time_zone: "UTC", // Intl.DateTimeFormat().resolvedOptions().timeZone,
        hide_date: false,
      },

      mapCenter: [0, 0],
      mapZoom: 0,
      image: null,
      pdf: null,
      savedPDF: null,
      currentImage: null,

      formValid: false,
      saving: false,

      recycledImagePath: null,

      departureCity: null,
      departureMarker: null,
      departureTimezone: null,
      departureDate: new Date().toISOString().substr(0, 10),
      departureTime: null,

      arrivalCity: null,
      arrivalMarker: null,
      arrivalTimezone: null,
      arrivalDate: new Date().toISOString().substr(0, 10),
      arrivalTime: null,

      invitedUsers: [],
      subgroups: [],
      feedback: null,

      reminders: reminders.options(this.$i18n),
      privacy: [
        {
          value: 2,
          text: this.$i18n.t("common.privacy.everyone.text"),
          hint: this.$i18n.t("common.privacy.everyone.hint"),
        },
        {
          value: 1,
          text: this.$i18n.t("common.optional"),
          hint: this.$i18n.t("common.privacy.optional.hint"),
        },
        {
          value: 3,
          text: this.$i18n.t("common.privacy.subgroups.text"),
          hint: this.$i18n.t("common.privacy.subgroups.hint"),
        },
        {
          value: 4,
          text: this.$i18n.t("common.privacy.custom.text"),
          hint: this.$i18n.t("common.privacy.custom.hint"),
        },
      ],
      rules: {
        required: (value) => !!value || "Required.",
      },

      usersMenu: false,

      lastClickedOrigin: false,
      startBounds: null,
    };
  },
  watch: {
    editTravel(editTravel) {
      console.log("isEditingTravel");
      if (editTravel) {
        this.setupEditTravel(editTravel);
      }
    },
    departureDate(newDateStr, oldDateStr) {
      const newDate = moment(newDateStr, "YYYY-MM-D").toDate();
      const arrivalDate = moment(this.arrivalDate, "YYYY-MM-D").toDate();
      if (this.arrivalDate === oldDateStr && newDate > arrivalDate) {
        this.arrivalDate = newDateStr;
      }
    },
  },
  methods: {
    openMap(type) {
      this.mapDialog = true;
      this.mapForDeparture = type === "departure";
      console.log("openMapfordapearute", this.mapForDeparture);
    },
    onPDFPicked(e) {
      const { files } = e.target;
      if (!files || files.length === 0) return;
      [this.pdf] = files;
    },
    clearPDF() {
      this.pdf = null;
      this.$refs.pdf.value = "";
    },
    cityChanged(city, type) {
      console.log("cityChanged", city);
      const timezone = this.timeZones.find((tz) => tz.timezone === city.time_zone);
      if (this.mapCenter[0] === 0) {
        this.mapCenter = [city.center.longitude, city.center.latitude];
        console.log(this.mapCenter);
        this.mapZoom = 10;
      }
      if (type === "departure") {
        this.departureTimezone = timezone;
        this.newTravel.destin.city = city.name;
      } else {
        this.arrivalTimezone = timezone;
        this.newEvent.location.city = city.name;
      }
    },
    onEditorReady(quill) {
      if (this.$props.editTravel) {
        if (this.newTravel.quill_description) {
          quill.setContents(JSON.parse(this.newTravel.quill_description).ops);
        } else {
          quill.setText(this.newTravel.description);
        }
      } else {
        const tripStart = moment(this.$store.state.trip.trip.start_date.toDate())
          .tz("UTC")
          .format("YYYY-MM-DD");

        this.departureDate = tripStart;
        this.arrivalDate = tripStart;
      }
    },
    selectedOrigin(event) {
      console.log("geo selected origin");
      console.log(event.result);
      const wikiCode =
        event.result.properties.wikiData ||
        event.result.context.find((context) => context.wikidata).wikidata;

      this.newTravel.origin = {
        coordinates: {
          lat: event.result.center[1],
          long: event.result.center[0],
        },
        address: event.result.place_name,
        wiki_code: wikiCode,
      };

      this.departureMarker = {
        coordinates: event.result.center,
        address: event.result.place_name,
        wiki_code: wikiCode,
      };

      mbAPI.getTimezone(event.result.center[1], event.result.center[0]).then((timeZone) => {
        this.newTravel.origin.time_zone = timeZone;
      });
    },
    selectedDestin(event) {
      console.log("geo selected destin");
      console.log(event.result);

      const wikiCode =
        event.result.properties.wikiData ||
        event.result.context.find((context) => context.wikidata).wikidata;
      this.newTravel.destin = {
        coordinates: {
          lat: event.result.center[1],
          long: event.result.center[0],
        },
        address: event.result.place_name,
        wiki_code: wikiCode,
      };

      this.arrivalMarker = {
        coordinates: event.result.center,
        address: event.result.place_name,
        wiki_code: wikiCode,
      };

      mbAPI.getTimezone(event.result.center[1], event.result.center[0]).then((timeZone) => {
        this.newTravel.destin.time_zone = timeZone;
      });
    },
    mapLoaded(payload) {
      console.log("map loaded!", this.startBounds);

      if (this.startBounds) {
        payload.map.fitBounds(this.startBounds, { animate: false, padding: 40 });
      }

      payload.map.on("click", (e) => {
        const { lngLat } = e;

        console.log("clicked on", lngLat);
        const marker = { coordinates: [lngLat.lng, lngLat.lat] };
        if (this.mapForDeparture) {
          this.departureMarker = marker;
        } else {
          this.arrivalMarker = marker;
        }

        mbAPI.reverseGeocode(lngLat.lat, lngLat.lng).then((result) => {
          console.log("reversGeocode->", result);
          this.$set(marker, "address", result.name);
          this.$set(marker, "wiki_code", result.wiki_code);
          this.$set(marker, "city", result.city);
        });
      });
    },
    removePin() {
      console.log("removing pin");

      let location;
      if (this.mapForDeparture) {
        this.departureMarker = null;
        location = this.newTravel.origin;
      } else {
        this.arrivalMarker = null;
        location = this.newTravel.destin;
      }
      this.$delete(location, "coordinates");
      this.$delete(location, "address");
      this.$delete(location, "wiki_code");
      this.$delete(location, "time_zone");
    },
    saveNewPoint() {
      this.mapDialog = false;

      let marker;
      let location;
      if (this.mapForDeparture) {
        marker = this.departureMarker;
        location = this.newTravel.origin;
      } else {
        marker = this.arrivalMarker;
        location = this.newTravel.destin;
      }

      if (marker) {
        location.coordinates = false;
        location.address = marker.address;
        location.wiki_code = marker.wiki_code;
        location.coordinates = {
          lat: marker.coordinates[1],
          long: marker.coordinates[0],
        };

        if (this.mapForDeparture) {
          this.departureCity = { id: marker.city };
        } else {
          this.arrivalCity = { id: marker.city };
        }

        // marker coordinates 0-long 1-lat
        const dep = this.mapForDeparture;
        console.log("saving new point");
        mbAPI.getTimezone(marker.coordinates[1], marker.coordinates[0]).then((timezone) => {
          location.time_zone = timezone;
          console.log("obtained timezone for ponint", timezone);
          if (dep) {
            this.departureTimezone = this.timeZones.find((tz) => tz.timezone === timezone);
            console.log("departureTimezone", this.departureTimezone);
          } else {
            this.arrivalTimezone = this.timeZones.find((tz) => tz.timezone === timezone);
            console.log("arrivalTimezone", this.arrivalTimezone);
          }
        });
      }
    },
    closeDialog() {
      this.$emit("closed");
    },
    toBoolArray(object) {
      if (!object) return null;
      return object.reduce((obj, id) => {
        // eslint-disable-next-line no-param-reassign,indent
        obj[id] = true;
        return obj;
      }, {});
    },
    setupEditTravel(travel) {
      console.log("setupEditTravel(,", travel);
      this.newTravel = {
        name: travel.name,
        reminder: travel.reminder,
        description: travel.description,
        quill_description: travel.quill_description,
        alarm: travel.alarm,
        origin: _.clone(travel.origin),
        destin: _.clone(travel.destin),
        privacy: travel.privacy,
        feedback: travel.feedback,
        attendance: travel.attendance,
        hide_date: travel.hide_date ?? false,
      };

      const imageUrl = this.$store.state.imageUrls[travel.id];
      if (imageUrl) {
        this.currentImage = imageUrl;
      } else if (travel.files && travel.files.header && !travel.files.header.includes("/")) {
        this.currentImage = travel.files.header;
      }
      if (travel.files && travel.files.pdf) {
        const pdfName = travel.files.pdf.split("/").pop().split("-");
        pdfName.shift();
        this.savedPDF = pdfName.join("-");
      }
      if (travel.origin.coordinates) {
        this.newTravel.origin.coordinates = {
          lat: travel.origin.coordinates.latitude,
          long: travel.origin.coordinates.longitude,
        };

        this.mapCenter = [
          this.newTravel.origin.coordinates.long,
          this.newTravel.origin.coordinates.lat,
        ];
        this.mapZoom = 13;
        this.departureMarker = {
          address: travel.origin.address,
          wiki_code: travel.origin.wiki_code,
          coordinates: this.mapCenter,
        };
      }
      if (travel.destin.coordinates) {
        this.newTravel.destin.coordinates = {
          lat: travel.destin.coordinates.latitude,
          long: travel.destin.coordinates.longitude,
        };

        if (this.mapCenter[0] === 0) {
          this.mapCenter = [
            this.newTravel.destin.coordinates.long,
            this.newTravel.destin.coordinates.lat,
          ];
        } else {
          console.log("calculating bounding box");
          this.startBounds = this.boundingBox([
            this.newTravel.origin.coordinates,
            this.newTravel.destin.coordinates,
          ]);
          console.log(this.startBounds);
        }

        this.arrivalMarker = {
          address: travel.destin.address,
          wiki_code: travel.destin.wiki_code,
          coordinates: [
            this.newTravel.destin.coordinates.long,
            this.newTravel.destin.coordinates.lat,
          ],
        };
      }

      const originDate = moment(travel.origin.date.toDate()).tz(
        this.newTravel.origin.time_zone || "UTC",
      );
      this.departureDate = originDate.format("YYYY-MM-DD");
      this.departureTime = {
        h: originDate.format("h"),
        mm: originDate.format("mm"),
        a: originDate.format("a"),
      };

      const destinDate = moment(travel.destin.date.toDate()).tz(
        this.newTravel.destin.time_zone || "UTC",
      );
      this.arrivalDate = destinDate.format("YYYY-MM-DD");
      this.arrivalTime = {
        h: destinDate.format("h"),
        mm: destinDate.format("mm"),
        a: destinDate.format("a"),
      };

      if (this.newTravel.origin.time_zone) {
        this.departureCity = this.cities.find(
          (c) => c.time_zone === this.newTravel.origin.time_zone,
        );
        this.departureTimezone = this.timeZones.find(
          (tz) => tz.timezone === this.newTravel.origin.time_zone,
        );
        if (this.departureCity && this.mapCenter[0] === 0) {
          this.mapCenter = [
            this.departureCity.center.longitude,
            this.departureCity.center.latitude,
          ];
        }
      }
      if (this.newTravel.destin.time_zone) {
        this.arrivalCity = this.cities.find((c) => c.time_zone === this.newTravel.destin.time_zone);
        this.arrivalTimezone = this.timeZones.find(
          (tz) => tz.timezone === this.newTravel.destin.time_zone,
        );
        if (this.arrivalCity && this.mapCenter[0] === 0) {
          this.mapCenter = [this.arrivalCity.center.longitude, this.arrivalCity.center.latitude];
        }
      }

      if (travel.privacy === 3) {
        this.invitedUsers = Object.keys(travel.users || {});
        this.subgroups = Object.keys(travel.subgroups || {});
      }
    },
    boundingBox(points) {
      if (!Array.isArray(points) || !points.length) {
        return undefined;
      }

      let w;
      let s;
      let e;
      let n;
      console.log(points);
      // Calculate the bounding box with a simple min, max of all latitudes and longitudes
      points.forEach((point) => {
        if (w === undefined) {
          s = point.lat;
          n = s;
          e = point.long;
          w = e;
          console.log(points);
        }

        if (point.lat > n) {
          n = point.lat;
        } else if (point.lat < s) {
          s = point.lat;
        }
        if (point.long > e) {
          e = point.long;
        } else if (point.long < w) {
          w = point.long;
        }
      });
      return [
        [w, s],
        [e, n],
      ];
    },
    saveEvent() {
      if (!this.$refs.form.validate()) {
        console.log("form not valid");
        this.feedback = this.$t("itinerary.NewEvent.feedBack1");
        return;
      }

      const validateDate = (date) => {
        console.log("validating date", date);
        if (!date || !date.h || !date.mm) {
          this.feedback = this.$t("itinerary.NewEvent.feedbackTime");
          return false;
        }
        if (!date.a) {
          this.feedback = this.$t("itinerary.NewEvent.feedbackTimeAMPM");
          return false;
        }
        return true;
      };

      if (!validateDate(this.departureTime) || !validateDate(this.arrivalTime)) {
        return;
      }

      this.feedback = null;

      const departureIsoTime = `${this.departureTime.h}:${
        this.departureTime.mm
      } ${this.departureTime.a.toLowerCase()}`;
      const isoDadepartureIsoDate = `${this.departureDate} ${departureIsoTime}`;
      const departureUtc = moment(isoDadepartureIsoDate, "YYYY-MM-D h:mm a").toDate();
      const departureOffset = moment.tz
        .zone(this.departureTimezone.timezone)
        .utcOffset(departureUtc.getTime());
      const departureTzDifference = departureOffset - departureUtc.getTimezoneOffset();

      const arrivalIsoTime = `${this.arrivalTime.h}:${
        this.arrivalTime.mm
      } ${this.arrivalTime.a.toLowerCase()}`;
      const isoDaarrivalIsoDate = `${this.arrivalDate} ${arrivalIsoTime}`;
      const arrivalUtc = moment(isoDaarrivalIsoDate, "YYYY-MM-D h:mm a").toDate();
      const arrivalOffset = moment.tz
        .zone(this.arrivalTimezone.timezone)
        .utcOffset(arrivalUtc.getTime());
      const arrivalTzDifference = arrivalOffset - arrivalUtc.getTimezoneOffset();

      this.newTravel.origin.time_zone = this.departureTimezone.timezone;
      this.newTravel.destin.time_zone = this.arrivalTimezone.timezone;

      this.newTravel.origin.date = new Date(
        departureUtc.getTime() + departureTzDifference * 60 * 1000,
      );
      this.newTravel.destin.date = new Date(arrivalUtc.getTime() + arrivalTzDifference * 60 * 1000);

      this.newTravel.privacy = Math.min(this.invitedMode, 3);

      const tripId = this.$store.getters.currentTripId;
      this.newTravel.origin.coordinates = firestore.getGeo(this.newTravel.origin.coordinates);
      this.newTravel.destin.coordinates = firestore.getGeo(this.newTravel.destin.coordinates);

      if (this.newTravel.privacy === 3) {
        console.log("event is private, selecting: ", this.invitedUsers);
        if (
          (this.subgroups == null || this.subgroups.length === 0) &&
          (this.invitedUsers == null || this.invitedUsers.length === 0)
        ) {
          this.feedback = this.$t("itinerary.NewEvent.feedBack3");
          return;
        }
        this.newTravel.users = this.toBoolArray(this.invitedUsers);
        this.newTravel.subgroups = this.toBoolArray(this.subgroups);
      }
      this.saving = true;

      if (this.recycledImagePath) {
        const files = this.newTravel.files || {};
        files.header = this.recycledImagePath;
        this.newTravel.files = files;
      }

      this.newTravel.quill_description = JSON.stringify(
        this.$refs.myQuillEditor.quill.getContents(),
      );
      this.newTravel.description = this.$refs.myQuillEditor.quill.getText();
      let id;
      if (this.$props.editTravel) {
        id = this.$props.editTravel.id;
      }

      firestore
        .writeTrackedDocument(tripId, "travels", this.newTravel, id)
        .then((docRef) => {
          if (docRef) {
            id = docRef.id;
          }
          console.log("Document written with ID: ", id);
          if (this.image || this.pdf) {
            const saveTwice = this.imageUrl != null && this.pdf != null;
            let savedOnce = false;
            const fileSaved = () => {
              if (!saveTwice || (saveTwice && savedOnce)) {
                this.saving = false;
                this.closeDialog();
              } else if (saveTwice) {
                savedOnce = true;
              }
            };
            if (this.image) {
              console.log("saving image file");
              const name = `${uuid.v4()}.${this.image.name.split(".").pop().toLowerCase()}`;
              const firPath = `groups/${tripId}/images/${name}`;
              storage.uploadFile(this.image, firPath).then((snapshot) => {
                console.log("Uploaded a blob or file!", snapshot);
                firestore.writeTrackedDocument(
                  tripId,
                  "travels",
                  {
                    "files.header": firPath,
                  },
                  id,
                );
                fileSaved();
              });
            }
            if (this.pdf) {
              console.log("saving pdf file");
              const name = `${id}-${this.pdf.name}`;
              const firPath = `groups/${tripId}/files/${name}`;
              console.log(firPath);
              storage.uploadFile(this.pdf, firPath).then((snapshot) => {
                console.log("Uploaded a blob or file!", snapshot);
                firestore.writeTrackedDocument(
                  tripId,
                  "travels",
                  {
                    "files.pdf": firPath,
                  },
                  id,
                );
                fileSaved();
              });
            }
            return;
          }
          console.log("no image, exit");
          this.saving = false;
          this.closeDialog();
        })
        .catch((error) => {
          this.feedback = error.message;
          this.saving = false;
          console.error("Error adding document: ", error);
        });
    },
  },
  computed: {
    cities() {
      return Object.values(this.$store.state.trip.cities).sort((a, b) => {
        if (!a.arrival_date || !b.arrival_date) return 0;
        return a.arrival_date < b.arrival_date ? -1 : 1;
      });
    },
    timeZones() {
      return timezones;
    },
    mapboxgl() {
      return Mapbox;
    },
    accessToken() {
      return mbAPI.accessToken;
    },
    mapStyle() {
      return mbAPI.mapStyle;
    },

    privacyHint() {
      const { privacy } = this.newTravel;
      return this.privacy.filter((item) => item.value === privacy)[0].hint;
    },
    allUsers() {
      return this.$store.getters.allUsers;
    },
    allSubgroups() {
      const subgroupsIds = Object.keys(this.$store.state.trip.subgroups);
      const subgroupsAll = this.$store.state.trip.subgroups;

      return subgroupsIds.map((id) => subgroupsAll[id]);
    },
  },
};
</script>

<style>
.mapboxgl-ctrl-top-right .mapboxgl-ctrl {
  z-index: auto;
}
</style>
